export default __webpack_public_path__ + "static/media/threads.989218a3.png";